const metaTag = document.querySelector('meta[name="policy-link"]');

if (metaTag && document.querySelector('.inquiry-form')) {
    const policyLink = metaTag.getAttribute('content');
    const policyLinks = document.querySelectorAll('a.inquiry-form__inject-policy-link');
    
    policyLinks.forEach(link => {
        link.setAttribute('href', policyLink);
    });
}